import React from "react"

import { OVERVIEW_ACCENTS } from "../../overview/OverviewCardIcon.tsx"

function NeedsInfoDot({ className = "mt-1.5" }: { className?: string }) {
  return (
    <span
      className={`inline-block h-2 w-2 shrink-0 rounded-full ${className}`}
      style={{ background: OVERVIEW_ACCENTS.orange.color }}
      aria-hidden
    />
  )
}

export { NeedsInfoDot }
